/*
 * Copyright (c) 2026 CalAmp Corp. All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';
import {toggleUserPrompt} from '../store/actions/user-prompt';

export type GridColumnType =
  | 'Account'
  | 'Entity'
  | 'VehicleManager'
  | 'ProfileManager';

const COLUMN_ERROR_MAP: Record<GridColumnType, (entity?: string) => string> = {
  Account        : () => translate('common:editors.errorMessages.account'),
  VehicleManager : (entity) => translate('common:editors.errorMessages.vehicleManager', {entity}),
  ProfileManager : () => translate('common:editors.errorMessages.profileManager'),
  Entity         : (entity) => translate('common:editors.errorMessages.entity', {entity})
};

export const handleColumnError = (column: GridColumnType, entityName?: string) => {
  const getMessage = COLUMN_ERROR_MAP[column];

  return toggleUserPrompt({
    message          : getMessage(entityName),
    autoHideDuration : 3000
  });
};
